import { useTravelerPhotos } from '../../shared/use_traveler_photos.js';
import type { VoucherPersonView } from '../models.js';
import { useVoucherEnv } from '../voucher_env.js';

/** Uma pessoa da linha de identidade do voucher, pronta para o avatar. */
export interface VoucherPerson {
  name: string;
  photoUrl: string | null;
}

/**
 * Quem viaja no voucher, na ordem da linha de identidade: o viajante e depois os
 * acompanhantes, each with the photo asked from the host by id (`photosFor`;
 * a URL expira, então não vem na vista). Nome vazio não vira avatar fantasma; id
 * ausente fica nas iniciais.
 */
export function useVoucherPeople(view: {
  travelerName?: string | null;
  travelerId?: string | null;
  companions?: VoucherPersonView[];
}): VoucherPerson[] {
  const { photosFor } = useVoucherEnv();
  const people: VoucherPersonView[] = [
    ...(view.travelerName ? [{ id: view.travelerId ?? null, name: view.travelerName }] : []),
    ...(view.companions ?? []).filter((person) => Boolean(person.name)),
  ];
  const photos = useTravelerPhotos(
    [...new Set(people.flatMap((person) => (person.id ? [person.id] : [])))],
    photosFor,
  );
  return people.map((person) => ({
    name: person.name,
    photoUrl: person.id ? (photos[person.id] ?? null) : null,
  }));
}
